import { css } from 'styled-components';

export const InputStyle = css`
    position: relative;
    width: 100%;
    height: 4.4rem;
    margin-bottom: 0.8rem;
    padding: 1.2rem 1rem;
    color: ${properties => properties.theme.color.black};
    font-family: ${properties => properties.theme.font.family.primary};
    font-size: 1.6rem;
    background-color: ${properties => properties.theme.color.white};
    background-clip: padding-box;
    border: 0.1rem solid ${properties => properties.theme.color.grey5};
    border-radius: 0.2rem;

    &:focus,
    &[aria-expanded='true'] {
        border: 0.1rem solid ${({ theme }) => theme.color.darkPurple};
        outline: none;
        box-shadow: 0 0 0 0.2rem ${({ theme }) => theme.color.purpleTint20};
    }

    &[aria-invalid='true'] {
        padding: 0.4rem;
        border: 0.2rem solid ${({ theme }) => theme.color.red};

        &:focus {
            box-shadow: 0 0 0 0.2rem ${({ theme }) => theme.color.redTint20};
        }
    }

    &:disabled {
        color: ${properties => properties.theme.color.grey5};
        background-color: ${properties => properties.theme.color.grey2};
        box-shadow: none;
    }
`;
